var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNonameProfilePic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_565",
    "data-name": "Group 565",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.505,
    height: 48.505,
    viewBox: "0 0 48.505 48.505",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 24.253,
    cy: 24.253,
    r: 24.253,
    fill: "#757575"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "user-solid_1_",
    "data-name": "user-solid (1)",
    d: "M11.1,12.689A6.345,6.345,0,1,0,4.758,6.345,6.344,6.344,0,0,0,11.1,12.689ZM8.838,15.069A8.836,8.836,0,0,0,0,23.906a1.472,1.472,0,0,0,1.472,1.472H20.734a1.472,1.472,0,0,0,1.472-1.472,8.836,8.836,0,0,0-8.838-8.838Z",
    transform: "translate(13.111 9.213)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonameProfilePic);
export default __webpack_public_path__ + "static/media/nonameProfilePic.334848ccca3e6a83560c60532f5732c8.svg";
export { ForwardRef as ReactComponent };